import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Copyright from "../Components/Copyright.js"
import history from '../History';
import FirebaseContext from "../Services/FirebaseContext"; 
import Misc from "../Services/Misc"; 
import ResponsiveDialog from "../Components/ResponsiveDialog"; 


const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});


class ResetPassword extends React.Component{

	constructor(props){
		super(props);
		
		this.email = "";
		
		this.state = {dialogOpen: false, 
					  resetButtonEnabled: true,
					  dialogMessage: "",
					  dialogTitle: ""}; 
		
		this.handleResetClick = this.handleResetClick.bind(this);
		this.handleDialogClose = this.handleDialogClose.bind(this);
	}
	
	handleResetDone(){
		history.push('/Signin');
	}
	
	handleResetClick(firebaseHelper){
		
		this.setState({resetButtonEnabled: false});
		
		firebaseHelper.SendPasswordResetEmail(this.email)
		
		.then(()=>{
			console.log("Reset DONE");
			this.setState({resetButtonEnabled: true});
			
			this.handleResetDone(); 
			
		})
		
		.catch((error)=>{
			console.log("Reset ERROR " + this.email);
			
			this.setState({
				resetButtonEnabled: true,
				dialogOpen: true,
				dialogMessage: "Sorry there seems to be a problem:" + error.message,
				dialogTitle: "Reset problem!" 
			});
		}); 
	}
	
	handleDialogClose(){
		this.setState({
			dialogOpen: false
		});
	}

	render(){
		
	  const {classes} = this.props

	  return (
		<Container component="main" maxWidth="xs">
		  <CssBaseline />
		  <div className={classes.paper}>
			<Avatar className={classes.avatar}>
			  <VpnKeyIcon />
			</Avatar>
			<Typography component="h1" variant="h5">
			  Reset Password
			</Typography>
			<form className={classes.form} noValidate>
			  <TextField
				variant="outlined"
				margin="normal"
				required
				fullWidth
				id="email"
				label="Email Address"
				name="email"
				autoComplete="email"
				autoFocus
				onChange={(e) => this.email = e.target.value}
			  />
			  
			  <FirebaseContext.Consumer>
			  { firebaseHelper=>(
				  <Button
					type="button"
					fullWidth
					variant="contained"
					color="primary"
					className={classes.submit}
					disabled={!this.state.resetButtonEnabled}
					onClick={()=>this.handleResetClick(firebaseHelper)}
				  >
					Reset password
				  </Button>
			  )}
			  </FirebaseContext.Consumer>
			  
			  <ResponsiveDialog open={this.state.dialogOpen} 
								handleClose={this.handleDialogClose}
								message={this.state.dialogMessage}
								title={this.state.dialogTitle}/>
			  
			  <Grid container>
				<Grid item>
				  <Link variant="body2" to= "/Signup" onClick={() => history.push('/Signup')}>
					{"Don't have an account? Sign Up"}
				  </Link>
				</Grid>
			  </Grid>
			</form>
		  </div>
		  <Box mt={8}>
			<Copyright />
		  </Box>
		</Container>
	  );
	  
	}
}

export default withStyles(useStyles)(ResetPassword)